module.exports = __webpack_public_path__ + "img/019-dumbbell.e3949f3c.svg";